import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { MButton } from "@/components/ui/atoms/MButtons";
import { useTranslation } from "react-i18next";
import MVideoPlayer from '@/components/ui/atoms/MVideoPlayer';

import logoFull from "../../assets/maatra_logo_white.svg";
import { useAuth } from "@/hooks/useAuth";
import { MAATRA_VIDEO_URL } from '@/utils/constants';

const Welcome: React.FC = () => {
  const { clearAllStorage } = useAuth();
  useEffect(() => {
    clearAllStorage();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    document.body.classList.add('auth-unlock-app-root');
    return () => {
      document.body.classList.remove('auth-unlock-app-root');
    };
  }, []);

  const navigate = useNavigate();
  const { t } = useTranslation();
  const [showMaatraVideo, setShowMaatraVideo] = React.useState(false);

  const ctas = [
    {
      label: t("welcome.cta1"),
      onClick: () => navigate("/login"),
    },
    {
      label: t("welcome.cta2"),
      onClick: () => navigate("/register/info"),
    },
    {
      label: t("welcome.cta3"),
      onClick: () => setShowMaatraVideo(true),
    },
  ];

  return (
    <div className="bg-onboarding-gradient overflow-auto">
      <div className="onboarding-ellipses">
        <div className="ellipse ellipse-1"></div>
        <div className="ellipse ellipse-2"></div>
        <div className="ellipse ellipse-3"></div>
        <div className="ellipse ellipse-4"></div>
        <div className="ellipse ellipse-5"></div>
      </div>
      <div className="auth-root">
        {/* Logo will be replaced with the actual one*/}
        <div className="w-full flex justify-start pt-[102px] pl-[3px]">
          <div className="auth-logo">
            <img
              src={logoFull}
              alt="Maatra Logo"
              className="object-contain w-full h-full"
              draggable={false}
            />
          </div>
        </div>
        {/* Headings */}
        <div className="w-full relative top-[56px] body-xl-semibold colour-text-inverse">
          {t("onboarding.title")}
        </div>
        <div className="w-full relative top-[64px] heading-h5-bold colour-text-inverse">
          {t("onboarding.subtitle")}
        </div>
        {/* Option Buttons */}
        <div className="flex flex-col w-full relative top-[310px] items-start gap-[16px] pb-[30px]">
          {ctas.map((cta) => (
            <MButton
              key={cta.label}
              variant="outline"
              size="lg"
              className="w-full button-onboarding"
              tabIndex={0}
              style={{ marginBottom: 8 }}
              onClick={cta.onClick}
            >
              {cta.label}
            </MButton>
          ))}
        </div>
      </div>
      <MVideoPlayer
        videoUrl={MAATRA_VIDEO_URL}
        open={showMaatraVideo}
        onClose={() => setShowMaatraVideo(false)}
        title="Get to know Maatra"
        autoplay={false}
      />
    </div>
  );
};

export default Welcome;
